import React, { Component } from "react";
import Cookies from "universal-cookie";
import { Button, Col, Form, Image, Input, InputNumber, Modal, Row } from "antd";
import { CreditCardOutlined, CheckCircleOutlined, CloseCircleOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { otodisService } from "../../services/OtodisService";

class ModalPaymentProgressive extends Component {
  token = new Cookies().get("_bbn_tn");

  constructor(props) {
    super(props);

    this.initState = {
      loadingButton: false,
      inputPkbTotal: Number(this.props.dataOrder?.vehicle_notice_data?.pkb) || 0,
      inputPkbBasic: Number(this.props.dataOrder?.pkb_cost) || 0,
      inputPkbProgressiveCost: Number(this.props.dataOrder?.progressive_cost) || 0,
      inputTotalBill: Number(this.props.dataOrder?.progressive_payment_detail?.total_bill) || 0,
      imageQris: this.props.dataOrder?.progressive_payment_detail?.qris_image_url || "",
      statusPayment: this.props.dataOrder?.progressive_payment_status || "PENDING",
      showMarketingData: false,
      inputMarketingId: "",
      inputMarketingName: "",
      inputMarketingBalance: 0,

      // imageQris: "https://otodis-bucket.s3.ap-southeast-1.amazonaws.com/vehicle-document/image/qris-progressive/ORD-HND-01400-25041213-W5TRUBW.png",
      // statusPayment: "QRIS_CREATED",
    };
    this.state = { ...this.initState };
  }

  componentDidUpdate(prevProps) {
    const prev = prevProps.dataOrder;
    const curr = this.props.dataOrder;

    if (
      curr &&
      (prev?.vehicle_notice_data?.pkb !== curr?.vehicle_notice_data?.pkb ||
        prev?.pkb_cost !== curr?.pkb_cost ||
        prev?.progressive_cost !== curr?.progressive_cost ||
        prev?.progressive_payment_detail?.total_bill !== curr?.progressive_payment_detail?.total_bill ||
        prev?.progressive_payment_detail?.qris_image_url !== curr?.progressive_payment_detail?.qris_image_url ||
        prev?.progressive_payment_status !== curr?.progressive_payment_status)
    ) {
      this.setState({
        loadingButton: false,
        inputPkbTotal: Number(curr?.vehicle_notice_data?.pkb) || 0,
        inputPkbBasic: Number(curr?.pkb_cost) || 0,
        inputPkbProgressiveCost: Number(curr?.progressive_cost) || 0,
        inputTotalBill: Number(curr?.progressive_payment_detail?.total_bill) || 0,
        imageQris: curr?.progressive_payment_detail?.qris_image_url || "",
        statusPayment: curr?.progressive_payment_status || "PENDING",
        showMarketingData: curr?.progressive_payment_detail?.qris_image_url === "PAYMENT_SALDO_DITAHAN",
        inputMarketingId: curr.marketing_id || "",
        inputMarketingName: curr.marketing_name || "",
      });
    }
  }

  handleCloseModal = () => {
    const curr = this.props.dataOrder;
    this.setState({
      loadingButton: false,
      inputPkbTotal: Number(curr?.vehicle_notice_data?.pkb) || 0,
      inputPkbBasic: Number(curr?.pkb_cost) || 0,
      inputPkbProgressiveCost: Number(curr?.progressive_cost) || 0,
      inputTotalBill: Number(curr?.progressive_payment_detail?.total_bill) || 0,
      imageQris: curr?.progressive_payment_detail?.qris_image_url || "",
      statusPayment: curr?.progressive_payment_status || "PENDING",
      showMarketingData: curr?.progressive_payment_detail?.qris_image_url === "PAYMENT_SALDO_DITAHAN",
      inputMarketingId: curr.marketing_id || "",
      inputMarketingName: curr.marketing_name || "",
      inputMarketingBalance: 0,
    });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  checkMarketingHeldBalance = async () => {
    try {
      this.setState({ loadingButton: true });

      const { order_code, marketing_id } = this.props.dataOrder;
      const params = { order_code, marketing_id };

      otodisService.setToken(this.token);
      const response = await otodisService.getHeldBalanceMarketing(params);

      if (response.data.success) {
        this.setState({
          inputMarketingId: response.data.data.marketing_id,
          inputMarketingName: response.data.data.marketing_name,
          inputMarketingBalance: response.data.data.marketing_balance,
          showMarketingData: true,
          loadingButton: false,
        });
      } else {
        throw new Error("Gagal mengambil data saldo ditahan.");
      }
    } catch (error) {
      this.setState({ loadingButton: false });
      Modal.error({
        title: "Error",
        content: error.message || "Terjadi kesalahan saat cek saldo ditahan.",
      });
    }
  };

  payProgressiveByHeldBalance = async () => {
    const dataOrder = this.props.dataOrder;
    const { inputPkbBasic, inputPkbProgressiveCost, inputPkbTotal } = this.state;
    if (Number(inputPkbBasic) < 1) {
      Modal.error({ title: "Validation Error", content: "Biaya PKB Dasar tidak valid" });
      return false;
    }
    if (Number(inputPkbProgressiveCost) < 1) {
      Modal.error({ title: "Validation Error", content: "Biaya PKB Progresif tidak valid" });
      return false;
    }
    if (Number(inputPkbProgressiveCost) + Number(inputPkbBasic) !== Number(inputPkbTotal)) {
      Modal.error({ title: "Validation Error", content: "Total Data Inputed != Total Biaya PKB" });
      return false;
    }

    try {
      this.setState({
        loadingButton: true,
      });
      const dataPayload = {
        service_bureau_code: dataOrder.service_bureau_code,
        order_code: dataOrder.order_code,
        marketing_id: this.state.inputMarketingId,
        basic_pkb_cost: Number(this.state.inputPkbBasic),
        progressive_cost: Number(this.state.inputPkbProgressiveCost),
      };

      otodisService.setToken(this.token);
      const createPaymentQris = await otodisService.payProgressivebyHeldBalanceMarketing(dataPayload);

      if (createPaymentQris.data.success === true) {
        const dataResp = createPaymentQris.data.data;

        const updatedOrder = {
          ...this.props.dataOrder,
          ...dataResp,
        };

        this.setState({
          loadingButton: false,
          imageQris: dataResp.progressive_payment_detail.qris_image_url,
          statusPayment: dataResp.progressive_payment_status,
        });

        if (this.props.onPaymentUpdate) {
          this.props.onPaymentUpdate(updatedOrder);
        }
      }
    } catch (error) {
      this.setState({
        loadingButton: false,
      });
      Modal.error({
        title: "Process Error",
        content: error.message,
      });
    }
  };

  handleFieldChange = (field, value) => {
    if (value !== this.state[field]) {
      this.setState({ [field]: value });

      if (field === "inputPkbBasic" || field === "inputPkbProgressiveCost") {
        const totalPkb = Number(this.state.inputPkbTotal);
        let inputPkbBasic = this.state.inputPkbBasic;
        let inputPkbProgressiveCost = this.state.inputPkbProgressiveCost;
        let totalBill = this.state.totalBill;

        if (field === "inputPkbBasic") {
          inputPkbBasic = Number(value);
          inputPkbProgressiveCost = totalPkb - inputPkbBasic;
        }

        if (field === "inputPkbProgressiveCost") {
          inputPkbProgressiveCost = Number(value);
          inputPkbBasic = totalPkb - inputPkbProgressiveCost;
          totalBill = Math.ceil(inputPkbProgressiveCost * 1.01);
        }

        this.setState({ inputTotalBill: totalBill, inputPkbBasic, inputPkbProgressiveCost });
      }
    }
  };

  handleCreatePayment = async () => {
    const dataOrder = this.props.dataOrder;
    const { inputPkbBasic, inputPkbProgressiveCost, inputPkbTotal } = this.state;
    if (Number(inputPkbBasic) < 1) {
      Modal.error({ title: "Validation Error", content: "Biaya PKB Dasar tidak valid" });
      return false;
    }
    if (Number(inputPkbProgressiveCost) < 1) {
      Modal.error({ title: "Validation Error", content: "Biaya PKB Progresif tidak valid" });
      return false;
    }
    if (Number(inputPkbProgressiveCost) + Number(inputPkbBasic) !== Number(inputPkbTotal)) {
      Modal.error({ title: "Validation Error", content: "Total Data Inputed != Total Biaya PKB" });
      return false;
    }

    try {
      this.setState({
        loadingButton: true,
      });
      const dataPayload = {
        service_bureau_code: dataOrder.service_bureau_code,
        vehicle_engine_number: dataOrder.vehicle_engine_number,
        basic_pkb_cost: Number(inputPkbBasic),
        progressive_cost: Number(inputPkbProgressiveCost),
      };

      otodisService.setToken(this.token);
      const createPaymentQris = await otodisService.createQrisProgressive(dataPayload);

      if (createPaymentQris.data.success === true) {
        const dataResp = createPaymentQris.data.data;

        const updatedOrder = {
          ...this.props.dataOrder,
          ...dataResp,
        };

        this.setState({
          loadingButton: false,
          imageQris: dataResp.progressive_payment_detail.qris_image_url,
          statusPayment: dataResp.progressive_payment_status,
        });

        if (this.props.onPaymentUpdate) {
          this.props.onPaymentUpdate(updatedOrder);
        }
      }
    } catch (error) {
      this.setState({
        loadingButton: false,
      });
      Modal.error({
        title: "Process Error",
        content: error.message,
      });
    }
  };

  handleUpdatePaymentStatus = async () => {
    const dataOrder = this.props.dataOrder;

    try {
      this.setState({
        loadingButton: true,
      });
      const dataPayload = {
        service_bureau_code: dataOrder.service_bureau_code,
        vehicle_engine_number: dataOrder.vehicle_engine_number,
      };

      otodisService.setToken(this.token);
      const updateStatusPayment = await otodisService.updatePaymentProgressive(dataPayload);

      if (updateStatusPayment.data.success === true) {
        const dataResp = updateStatusPayment.data.data;

        const updatedOrder = {
          ...this.props.dataOrder,
          ...dataResp,
        };

        this.setState({
          loadingButton: false,
          statusPayment: dataResp.progressive_payment_status,
        });

        if (this.props.onPaymentUpdate) {
          this.props.onPaymentUpdate(updatedOrder);
        }
      }
    } catch (error) {
      this.setState({
        loadingButton: false,
      });
      Modal.error({
        title: "Process Error",
        content: error.message,
      });
    }
  };

  render() {
    const dataOrder = this.props.dataOrder;

    return (
      <Modal title="Payment Progresif" visible={this.props.visible} onCancel={this.handleCloseModal} footer={null} width={700} style={{ maxHeight: "80vh" }} closable={false} keyboard={false} maskClosable={false}>
        {dataOrder && (
          <div style={{ maxHeight: "calc(80vh - 55px)", overflowY: "auto" }}>
            <Form name="form-filter" layout="vertical">
              <Row>
                <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }}>
                  <Form.Item label="Nomor Mesin">
                    <Input value={`${dataOrder.vehicle_engine_number}`} disabled />
                  </Form.Item>
                  {this.state.showMarketingData ||
                    (this.state.inputMarketingId && (
                      <>
                        <Form.Item label="ID Marketing">
                          <Input value={this.state.inputMarketingId} disabled />
                        </Form.Item>
                        <Form.Item label="Nama Marketing">
                          <Input value={this.state.inputMarketingName} disabled />
                        </Form.Item>
                        <Form.Item label="Sisa Saldo Ditahan">
                          <InputNumber value={this.state.inputMarketingBalance} disabled style={{ width: "100%", textAlign: "right" }} formatter={(value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")} parser={(value) => value.replace(/[^0-9]/g, "")} />
                        </Form.Item>
                      </>
                    ))}

                  <Form.Item label="Biaya PKB">
                    <InputNumber value={this.state.inputPkbTotal} placeholder="Biaya PKB" style={{ width: "100%", textAlign: "right" }} formatter={(value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")} parser={(value) => value.replace(/[^0-9]/g, "")} disabled />
                  </Form.Item>
                  <Form.Item label="Biaya PKB Dasar">
                    <InputNumber
                      value={this.state.inputPkbBasic}
                      placeholder="Total Biaya PKB"
                      onChange={(value) => this.handleFieldChange("inputPkbBasic", value)}
                      style={{ width: "100%", textAlign: "right" }}
                      formatter={(value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      parser={(value) => value.replace(/[^0-9]/g, "")}
                      disabled={this.state.statusPayment !== "PENDING"}
                    />
                    <Form.Item label="Biaya PKB Progresif">
                      <InputNumber
                        value={this.state.inputPkbProgressiveCost}
                        placeholder="Biaya PKB"
                        onChange={(value) => this.handleFieldChange("inputPkbProgressiveCost", value)}
                        style={{ width: "100%", textAlign: "right" }}
                        formatter={(value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        parser={(value) => value.replace(/[^0-9]/g, "")}
                        disabled={this.state.statusPayment !== "PENDING"}
                      />
                    </Form.Item>
                    <Form.Item label="Total Bill">
                      <InputNumber value={this.state.inputTotalBill} placeholder="Biaya PKB" style={{ width: "100%", textAlign: "right" }} formatter={(value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")} parser={(value) => value.replace(/[^0-9]/g, "")} disabled />
                    </Form.Item>
                  </Form.Item>
                </Col>
                {["PAID", "QRIS_CREATED"].includes(this.state.statusPayment) && (
                  <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }}>
                    <center>
                      {this.state.imageQris.startsWith("http") ? (
                        <>
                          <Image width={"inherit"} src={this.state.imageQris} />
                          <br />
                          <small>
                            <i>*) Qris hanya berlaku selama 60 menit dari waktu pembuatan. jika sudah kadaluarsa maka progresif tidak bisa di bayar</i>
                          </small>
                        </>
                      ) : (
                        <div style={{ fontSize: "20px", fontWeight: "bold", padding: "20px 0", border: "1px solid #DDD", marginTop: 20, marginBottom: 10 }}>DIBAYAR DARI SALDO MARKETING</div>
                      )}
                    </center>
                  </Col>
                )}

                <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }}>
                  {this.state.statusPayment === "PENDING" && this.state.showMarketingData && (
                    <Button type="primary" onClick={this.payProgressiveByHeldBalance} icon={<CreditCardOutlined />} style={{ background: "#17a2b8", borderColor: "#17a2b8", paddingLeft: 5, marginRight: 5 }} loading={this.state.loadingButton}>
                      Bayar dengan Saldo Ditahan
                    </Button>
                  )}
                  {this.state.statusPayment === "PENDING" && !this.state.showMarketingData && (
                    <React.Fragment>
                      <Button onClick={() => this.handleCreatePayment()} type="primary" icon={<CreditCardOutlined />} style={{ background: "#28a745", borderColor: "#28a745", paddingLeft: 5, marginRight: 5 }} loading={this.state.loadingButton}>
                        Buat Pembayaran
                      </Button>
                      <Button onClick={this.checkMarketingHeldBalance} type="primary" icon={<QuestionCircleOutlined />} loading={this.state.loadingButton} style={{ background: "#007bff", borderColor: "#007bff", paddingLeft: 5, marginRight: 5 }}>
                        Check Saldo Ditahan
                      </Button>
                    </React.Fragment>
                  )}
                  {this.state.statusPayment === "QRIS_CREATED" && (
                    <Button onClick={() => this.handleUpdatePaymentStatus()} type="primary" icon={<CheckCircleOutlined />} loading={this.state.loadingButton} style={{ paddingLeft: 5, marginRight: 5 }}>
                      Update Status Bayar
                    </Button>
                  )}
                  <Button onClick={this.handleCloseModal} type="primary" danger icon={<CloseCircleOutlined />} loading={this.state.loadingButton} style={{ paddingLeft: 5, marginRight: 5 }}>
                    Tutup
                  </Button>
                  <br />
                  <small>
                    <i>*) Ada penambahan 1% dari nilai PKB Progresif untuk biaya admin</i>
                  </small>
                </Col>
              </Row>
            </Form>
          </div>
        )}
      </Modal>
    );
  }
}

export default ModalPaymentProgressive;
